import React from 'react'
import { get } from 'lodash'
import { ReactTable, searchVehicle } from '../../feature-react-table'
import { useSearchVehiclesDetailLazyQuery } from '../generated/graphql'
import type { SearchCardDetailProps } from '../types'

const {
    accessors: { account, checkedInAt, lastSaleDate, makeModelYear, odometer, status, stockNumber },
    Cells: { Account, MakeModelYear },
} = searchVehicle

const columns = [
    {
        Header: 'Vehicle',
        accessor: makeModelYear,
        Cell: MakeModelYear,
    },
    {
        Header: 'Account',
        accessor: account,
        Cell: Account,
    },
    {
        Header: 'Odometer',
        accessor: odometer,
    },
    {
        Header: 'Checked In',
        accessor: checkedInAt,
    },
    {
        Header: 'Last Sale Date',
        accessor: lastSaleDate,
    },
    {
        Header: 'Status',
        accessor: status,
    },
]

const mobileColumns = [
    {
        Header: 'Vehicle',
        accessor: makeModelYear,
        Cell: MakeModelYear,
    },
    {
        Header: 'Stock #',
        accessor: stockNumber,
    },
    {
        Header: 'Status',
        accessor: status,
    },
    {
        Header: 'Checked In',
        accessor: checkedInAt,
    },
]

export const SearchVehiclesDetailComponent: React.VFC<SearchCardDetailProps> = ({
    searchString,
    title,
}: SearchCardDetailProps) => {
    return (
        <ReactTable
            shareMetaData={{ shareSubject: 'Vehicles' }}
            columns={columns}
            mobileColumns={mobileColumns}
            countPath="auction.search.vehicleCount"
            listPath="auction.search.vehicleResult"
            lazyQueryHook={useSearchVehiclesDetailLazyQuery}
            queryOptions={{ variables: { searchString } }}
            title={({ res }): string => title || get(res, 'auction.search.searchStringDisplay', 'Search Results')}
        />
    )
}

export const searchVehiclesColumns = columns
export const searchVehiclesMobileColumns = mobileColumns
